
const getEnv = (key, fallback) => {
  if (typeof window !== 'undefined' && window.__ENV && window.__ENV[key]) {
    return window.__ENV[key];
  }
  return fallback;
};

export const config = {
  PERSISTENCE_PROVIDER: getEnv('PERSISTENCE_PROVIDER', process.env.PERSISTENCE_PROVIDER),
  
  // Supabase
  SUPABASE_URL: getEnv('SUPABASE_URL', process.env.SUPABASE_URL),
  SUPABASE_ANON_KEY: getEnv('SUPABASE_ANON_KEY', process.env.SUPABASE_ANON_KEY),
  SUPABASE_SERVICE_ROLE_KEY: getEnv('SUPABASE_SERVICE_ROLE_KEY', process.env.SUPABASE_SERVICE_ROLE_KEY),
  
  // Appwrite
  APPWRITE_URL: getEnv('APPWRITE_URL', process.env.APPWRITE_URL),
  APPWRITE_PROJECT_ID: getEnv('APPWRITE_PROJECT_ID', process.env.APPWRITE_PROJECT_ID),
  APPWRITE_DATABASE_ID: getEnv('APPWRITE_DATABASE_ID', process.env.APPWRITE_DATABASE_ID),
  
  // PocketBase
  POCKETBASE_URL: getEnv('POCKETBASE_URL', process.env.POCKETBASE_URL)
};
